<template>
  <div id="app-gdpr-data" class="show-gdpr-data">
    <div class="content">
      <h1 class="sr-only">Meine Daten – Kundendaten Zusammenfassung</h1>
      <h2 class="text-3xl text-align-left full-width">Kundendaten Zusammenfassung</h2>

      <div class="container-box">
        <div v-if="currentCustomer !== null">
          <div class="data">
            <div class="col" v-for="data in getGdprEntries" :key="data.name">
              <p class="text-lg">{{ data.name }}:</p>
              <p v-html="formatString(data.value)"></p>
            </div>
          </div>
          <button @click="downloadCSV()" type="button" class="text-sm download-data-button">
            <span>Meine gespeicherten Daten im csv-Format herunterladen</span>
            <img src="/files/lidl/images/new-icons/svg/chevron-right.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import FileSaver from 'file-saver'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'ShowGDPRData',
  components: {},
  computed: {
    getGdprEntries() {
      return this.currentCustomer?.gdprEntries
    },
    slotData() {
      return {
        currentCustomer: this.currentCustomer
      }
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    return {
      currentCustomer: null,
      loading: false,
      loadingCSV: false
    }
  },
  methods: {
    downloadCSV: function() {
      this.loadingCSV = true
      const me = this

      axios
        .get('/api/document/gdpr/datenauskunft.csv', {
          baseURL: this.$config.apiUrl || '',
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
            Accept: 'application/pdf'
          }
        })
        .then(response => {
          this.loadingCSV = false
          const file = new Blob([response.data], { type: response.headers['content-type'] })
          FileSaver.saveAs(file, 'datenauskunft.csv')
        })
        .catch(reason => {
          me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
        })
    },
    formatString: function(IBAN) {
      if (IBAN.includes('********')) {
        return IBAN.split('').map(char => `<span style="vertical-align: middle">${char}</span>`).join('') // this fixes the misalignment of the *
      } else {
        return IBAN
      }
    }
  },
  apollo: {
    currentCustomer: function() {
      this.loading = true
      return wrapQuery(
        gql`
          query GDPRData {
            currentCustomer {
              gdprEntries {
                name
                value
              }
            }
          }
        `,
        this,
        'currentCustomer',
        {},
        () => {
          this.loading = false
        },
        {
          fetchPolicy: 'cache-first'
        },
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>
